module.exports = __webpack_public_path__ + "static/media/Mask Group 178.be51b3f9.svg";